import { render, staticRenderFns } from "./homepageTV.vue?vue&type=template&id=72e5560c&scoped=true&"
import script from "./homepageTV.vue?vue&type=script&lang=js&"
export * from "./homepageTV.vue?vue&type=script&lang=js&"
import style0 from "./homepageTV.vue?vue&type=style&index=0&lang=css&"
import style1 from "./homepageTV.vue?vue&type=style&index=1&id=72e5560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5560c",
  null
  
)

export default component.exports